/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React from "react";
//Packages
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
//Icon Library
import { MdHealthAndSafety } from "react-icons/md";

function SpecialRequirements(props) {
  const string = props.specialRequirements;
  const renderTooltip = props => (
    <Tooltip id="button-tooltip" {...props}>{string}</Tooltip>
  ); 

  return (
      <OverlayTrigger placement="top" overlay={renderTooltip}>
      <span><MdHealthAndSafety /></span>
      </OverlayTrigger>
  );
}

export default SpecialRequirements;